import axios from 'axios';

/*
  Base axios instance used by all application
  TODO: Transform in a plugin for Vue or use vue-axios library
*/

const baseAxios = axios.create({ baseURL: process.env.VUE_APP_API_BASE });
/**
 * Axios base instance with base url set at VUE_APP_API_BASE environment variable
 */
export default baseAxios;

export const originalAxios = axios;

/**
 * Set a header in the base instance
 * @param {string} header header to be set
 * @param {any} value new value for header
 */
export const setCommonHeader = (header: string, value: string) => {
  baseAxios.defaults.headers.common[header] = value;
};

/**
 * Unset a header in the base instance
 * @param {string} header header that will be unset
 */
export const unsetCommonHeader = (header: string) => {
  delete baseAxios.defaults.headers.common[header];
};